import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SetNewPasswordRequest } from 'app/models/ss-api/requests/set.new.password.request';
import { ssApiService } from 'app/services/ss-api.service';
import { xToastr, ToastrTypes } from 'app/shared/Toastr';

@Component({
  selector: 'reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

  IsBusy: boolean = false;

  ResetPasswordForm: UntypedFormGroup;

  // ID's FROM ROUTE PARAMTERS
  routeParams: object;
  ResetPasswordAuth: string;

  // DATA SUBSCRIPTION VARIABLES
  paramsSubscribe: any;

  constructor(private route: ActivatedRoute, private api: ssApiService, private router: Router) {
    this.paramsSubscribe = this.route.params.subscribe(params => this.routeParams = params);
  }

  ngOnInit() {

    this.ResetPasswordForm = new UntypedFormGroup({
      'password': new UntypedFormControl('', [Validators.required, Validators.minLength(5)]),
      'passwordConfirm': new UntypedFormControl('', [Validators.required, Validators.minLength(5)]),
    });

    // check param
    if (this.routeParams['resetPasswordAuth'] == undefined)
      window.location.href = 'http://www.structurestudios.com';

    // set param
    this.ResetPasswordAuth = this.routeParams['resetPasswordAuth'];

  }

  ngOnDestroy() {
    this.paramsSubscribe.unsubscribe();
  }

  isCompareValid(myField: string, compareField: string): boolean {
    return myField == compareField;
  }

  GetSetNewPasswordRequest(): SetNewPasswordRequest {

    let data = new SetNewPasswordRequest();

    data.ResetPasswordID = this.ResetPasswordAuth;
    data.NewPassword = this.ResetPasswordForm.get('password').value;

    return data;
  }


  onResetPasswordFormSubmit() {


    this.IsBusy = true;
    if ( this.ResetPasswordForm.get('password').value == '' ) {
      this.IsBusy = false;
      xToastr.ShowToast(ToastrTypes.Error, 'Oops', 'Please enter your new password.' );
      return;
    }else if ( !this.isCompareValid( this.ResetPasswordForm.get('password').value, this.ResetPasswordForm.get('passwordConfirm').value) ) {
      this.IsBusy = false;
      xToastr.ShowToast(ToastrTypes.Error, 'Oops', 'New passwords must match!' );
      return;
    }

    let data = this.GetSetNewPasswordRequest();

    let subscription = this.api.SetNewPassword(data).subscribe(
      (result) => {
        subscription.unsubscribe();

        if (!result.Result) {
          // error -> link not valid or expired

          this.IsBusy = false;
          xToastr.ShowToast(ToastrTypes.Error, 'Error', result.Message );

          return;
        }

        this.IsBusy = false;
        this.router.navigate(['authentication/signin']);

        xToastr.ShowToast(ToastrTypes.Success, 'Success!', 'Your password has been successfully changed.' );

      },
      (error) => {
        // error -> http or connection error or link not valid or expired
        this.IsBusy = false;
        xToastr.ShowToast(ToastrTypes.Error, error.FriendlyTitle, error.FriendlyMessage );
      });

  }

}
